import React from 'react'

interface IProps {
  duration: string
  [key: string]: any
}

const VideoDuration: React.FC<IProps> = ({ duration = '', ...props }) => {
  return (
    <div className={`video-btn`} {...props}>
      {duration}
      <style jsx>
        {`
          .video-btn {
            display: block;
            font-size: 10px;
            color: hsla(0, 0%, 100%, 0.9);
            overflow: hidden;
            padding: 0 6px 0 4px;
            border-radius: 15px;
            background-color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
            height: 20px;
          }
          .video-btn::before {
            content: '';
            display: inline-block;
            background: url(${require('static/play-arrow.png')}) no-repeat
              center / cover;
            width: 10px;
            height: 10px;
            vertical-align: baseline;
            margin-right: 2px;
          }
        `}
      </style>
    </div>
  )
}

export default VideoDuration
